import { Box } from 'src/components/Box';
import { LogoImage } from 'src/shared/LogoImage';

interface Props {
  imageUrl?: string;
  height?: number | string;
  width: number | string;
}
export const ImageOrLogo: React.FC<Props> = ({ imageUrl, height, width }) => {
  if (imageUrl) {
    return (
      <Box
        component="img"
        src={imageUrl}
        sx={{
          borderRadius: 1, // Use '50%' for a circular image, or use a specific value for rounded corners
          height: height, // Adjust the height as needed
          width: width,
        }}
      />
    );
  }

  return <LogoImage height={height} width={width} />;
};
